import Button from '@ui/buttons/Button'
import FormInputDate from '@ui/forms/Date/FormInputDate'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { useBirthDateForm } from './useBirthDateForm'
import { BirthdateValues } from '@ca/common'

const BirthDateNode = (props: ReturnType<typeof useBirthDateForm>) => {
  const { form, onSubmit, isLoading } = props
  const { t } = useTranslation(['ui', 'user'])
  return (
    <View className="gap-8">
      <FormProvider {...form}>
        <FormInputDate
          control={form.control}
          label={t('user:birthDate')}
          name="birth_date"
          defaultDate={BirthdateValues.default}
          min={BirthdateValues.min}
          max={BirthdateValues.max}
        />
      </FormProvider>
      <View className="w-max self-start">
        <Button
          variant="outlined"
          label={t('ui:update')}
          loading={isLoading}
          onPress={onSubmit}
        />
      </View>
    </View>
  )
}

export default BirthDateNode
